(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-auto-update]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var CATEGORY_TYPES = {
      refrigeration: ['Refrigerator', 'Freezer', 'Fridge Drawer', 'Ice Maker', 'Undercounter', 'Undercounter Beverage', 'Undercounter Wine', 'Wine Cooler'],
      ranges: ['Range', 'Rangetop'],
      ovens: ['Single Oven', 'Double Oven', 'Steam Oven', 'Convection Steam Oven', 'Speed Oven', 'Microwave', 'Microwave Oven', 'Warming Drawer', 'Cup Warmer'],
      cooktops: ['Cooktop', 'Cooktop Module', 'Countertop Griddle'],
      ventilation: ['Hood', 'Hood Liner', 'Liner', 'Blower', 'BBQ Liner'],
      dishwashers: ['Dishwasher'],
      outdoor: ['BBQ', 'Side Burner']
    };

    document.querySelectorAll('[id^="collection-page-"]').forEach(function (root) {
      var grid = root.querySelector('[data-collection-grid]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-collection-item]'));
      var countEls = document.querySelectorAll('[data-collection-count]');
      var emptyEl = root.querySelector('[data-collection-empty]');
      var vendorInputs = root.querySelectorAll('[data-filter-vendor]');
      var typeInputs = root.querySelectorAll('[data-filter-type]');
      var sizeInputs = root.querySelectorAll('[data-filter-size]');
      var searchInput = root.querySelector('[data-filter-search]');
      var minInput = root.querySelector('[data-filter-price-min]');
      var maxInput = root.querySelector('[data-filter-price-max]');
      var inStockInput = root.querySelector('[data-filter-instock]');
      var sortSelect = root.querySelector('[data-sort]');
      var clearButton = root.querySelector('[data-filter-clear]');
      var tabs = root.querySelectorAll('[data-cat]');
      var filtersPanel = root.querySelector('[data-filters]');
      var filtersToggle = root.querySelector('[data-filters-toggle]');
      var activeCat = '';

      function checkedValues(inputs) {
        return Array.prototype.slice.call(inputs)
          .filter(function (input) { return input.checked; })
          .map(function (input) { return input.value; });
      }

      function applyFilters() {
        var vendors = checkedValues(vendorInputs);
        var types = checkedValues(typeInputs);
        var sizes = checkedValues(sizeInputs);
        var catTypes = activeCat ? CATEGORY_TYPES[activeCat] || [] : null;
        var terms = searchInput && searchInput.value.trim() !== '' ? searchInput.value.trim().toLowerCase().split(/\s+/) : [];
        var min = minInput && minInput.value !== '' ? parseFloat(minInput.value) : null;
        var max = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : null;
        var inStockOnly = inStockInput && inStockInput.checked;
        var visible = 0;

        items.forEach(function (item) {
          var d = item.dataset;
          var price = parseFloat(d.price);
          var show =
            (vendors.length === 0 || vendors.indexOf(d.vendor) !== -1) &&
            (types.length === 0 || types.indexOf(d.type) !== -1) &&
            (!catTypes || catTypes.indexOf(d.type) !== -1) &&
            (sizes.length === 0 || sizes.indexOf(d.size) !== -1) &&
            terms.every(function (t) { return d.search.indexOf(t) !== -1; }) &&
            (min === null || price >= min) &&
            (max === null || price <= max) &&
            (!inStockOnly || d.available === 'true');
          item.hidden = !show;
          if (show) visible += 1;
        });

        countEls.forEach(function (el) { el.textContent = visible; });
        if (emptyEl) emptyEl.hidden = visible !== 0;
      }

      function applySort() {
        if (!grid || !sortSelect) return;
        var mode = sortSelect.value;
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
          if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
          if (mode === 'savings') return b.dataset.save - a.dataset.save;
          return a.dataset.index - b.dataset.index;
        });
        sorted.forEach(function (item, position) {
          item.style.order = position;
          grid.appendChild(item);
        });
      }

      function setCategory(cat) {
        activeCat = CATEGORY_TYPES[cat] ? cat : '';
        tabs.forEach(function (tab) { tab.classList.toggle('is-active', tab.dataset.cat === activeCat); });
        var url = new URL(window.location.href);
        if (activeCat) url.searchParams.set('cat', activeCat); else url.searchParams.delete('cat');
        window.history.replaceState(null, '', url);
        applyFilters();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { setCategory(tab.dataset.cat); });
      });
      [vendorInputs, typeInputs, sizeInputs].forEach(function (list) {
        list.forEach(function (input) { input.addEventListener('change', applyFilters); });
      });
      [searchInput, minInput, maxInput].forEach(function (input) {
        if (input) input.addEventListener('input', applyFilters);
      });
      if (inStockInput) inStockInput.addEventListener('change', applyFilters);
      if (sortSelect) sortSelect.addEventListener('change', applySort);
      if (filtersToggle) {
        filtersToggle.addEventListener('click', function () { filtersPanel.classList.toggle('is-open'); });
      }
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          [vendorInputs, typeInputs, sizeInputs].forEach(function (list) {
            list.forEach(function (input) { input.checked = false; });
          });
          if (searchInput) searchInput.value = '';
          if (minInput) minInput.value = minInput.defaultValue;
          if (maxInput) maxInput.value = maxInput.defaultValue;
          if (inStockInput) inStockInput.checked = true;
          setCategory('');
        });
      }

      var params = new URLSearchParams(window.location.search);
      if (searchInput && params.get('q')) searchInput.value = params.get('q');
      applySort();
      setCategory(params.get('cat') || '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    var menu = document.querySelector('[data-mobile-menu]');
    var search = document.querySelector('[data-search]');
    if (!header) return;

    function syncDrawerTop() {
      document.documentElement.style.setProperty('--drawer-top', header.getBoundingClientRect().bottom + 'px');
    }

    if (menu) {
      menu.addEventListener('toggle', function () {
        syncDrawerTop();
        document.body.style.overflow = menu.open ? 'hidden' : '';
      });
    }

    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) {
          var input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var target = document.getElementById(thumb.dataset.target);
      var img = target && target.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = thumb.dataset.fullSrc;
      }
      thumb.parentElement.querySelectorAll('.pdp__thumb').forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
